import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-loader-dialog',
  templateUrl: './loader-dialog.html'
})
export class LoaderDialog {

  constructor(
    public dialogRef: MatDialogRef<LoaderDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

}
